export var CompanyClientStatus = /*#__PURE__*/function (CompanyClientStatus) {
  CompanyClientStatus["New"] = "New";
  CompanyClientStatus["Pending"] = "Pending";
  CompanyClientStatus["Contracted"] = "Contracted";
  return CompanyClientStatus;
}(CompanyClientStatus || {});
export const companyClientStatusLabels = {
  [CompanyClientStatus.Pending]: "Vertrag ausstehend",
  [CompanyClientStatus.Contracted]: "Aktiver Vertrag",
  [CompanyClientStatus.New]: "Neukunde"
};